import * as React from 'react';
import { styles } from './styles';
import { SlideInVertical } from '@joykit/transitions';
import { CSSTransition } from 'react-transition-group';
import { ANIMATION_DURATION_MS } from '@joykit/variables/animations';
import { Portal } from 'react-portal';
import { cx } from 'emotion';

interface Props {
  in: boolean;
  children: React.ReactNode;
  className?: string;
  node?: Element | null;
}

class BottomBanner extends React.Component<Props> {
  render(): React.ReactNode {
    return (
      <Portal node={this.props.node}>
        <CSSTransition in={this.props.in} classNames="slide" timeout={ANIMATION_DURATION_MS}>
          <SlideInVertical as="css" className={cx(styles.container, this.props.className)}>
            {this.props.children}
          </SlideInVertical>
        </CSSTransition>
      </Portal>
    );
  }
}

export { BottomBanner };
